<template>
  <v-container>
    <v-form>
      <v-layout justify-center>
        <v-container>
          <v-layout>
            <v-flex>
              <botones-preguntas></botones-preguntas>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex></v-flex>
          </v-layout>
          <v-layout> </v-layout>
        </v-container>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import BotonesPreguntas from "@/modules/configuration/commonsviews/BotonesProcesoPreguntas.vue";

export default {
  name: "proceso-preguntas",
  components: {
    BotonesPreguntas,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
    contratoId: "",
  },
  data() {
    return {};
  },
  computed: {},
  created() {
    this.$store.commit("tab_state", "Proceso");
  },
  methods: {},
};
</script>
